<template>
  <Admin>
    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center" v-if="!selectedCompany.isDemo">
          <v-col cols="12"/>
        </v-row>
        <div v-else class="align-center justify-center" style="height: 200px; display: flex;">
          No Permission
        </div>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from '../../components/admin/admin-main-template'
import {mapState} from "vuex";

export default {
  name: 'Settings',
  components: {
    Admin,
  },
  computed: mapState({
    selectedCompany: state => state.companies.selectedCompany,
  }),
}
</script>
